import React, { useState } from "react";
import styled from "styled-components";
import AtomsGauge from "./AutodisplayView/components/atoms/AtomsGauge";

const AtomsGaugeTest = () => {
  // 게이지 테스트용 상태값들
  const [tempValue, setTempValue] = useState(23);
  const [humidityValue, setHumidityValue] = useState(44);
  const [vocValue, setVocValue] = useState(85);
  const [co2Value, setCo2Value] = useState(720);

  return (
    <Container>
      <Header>
        <Title>AtomsGauge 컴포넌트 테스트</Title>
        <Description>슬라이더로 값을 변경하여 동적 게이지의 동작을 확인할 수 있습니다.</Description>
      </Header>

      <TestSection>
        {/* 컨트롤 패널 */}
        <ControlPanel>
          <ControlGroup>
            <ControlLabel>온도: {tempValue}°C</ControlLabel>
            <ControlSlider 
              type="range" 
              min="0" 
              max="40" 
              value={tempValue}
              onChange={(e) => setTempValue(Number(e.target.value))}
            />
            <ControlInfo>18-25°C 좋음, 26-30°C 보통</ControlInfo>
          </ControlGroup>
          
          <ControlGroup>
            <ControlLabel>습도: {humidityValue}%</ControlLabel>
            <ControlSlider 
              type="range" 
              min="0" 
              max="100" 
              value={humidityValue}
              onChange={(e) => setHumidityValue(Number(e.target.value))}
            />
            <ControlInfo>40-60% 좋음, 30-39% 보통</ControlInfo>
          </ControlGroup>
          
          <ControlGroup>
            <ControlLabel>VOC: {vocValue}ppm</ControlLabel>
            <ControlSlider 
              type="range" 
              min="0" 
              max="200" 
              value={vocValue}
              onChange={(e) => setVocValue(Number(e.target.value))}
            />
            <ControlInfo>0-50ppm 좋음, 51-100ppm 보통</ControlInfo>
          </ControlGroup>
          
          <ControlGroup>
            <ControlLabel>CO2: {co2Value}ppm</ControlLabel>
            <ControlSlider 
              type="range" 
              min="400" 
              max="2000" 
              value={co2Value}
              onChange={(e) => setCo2Value(Number(e.target.value))}
            />
            <ControlInfo>상태 표시 없음</ControlInfo>
          </ControlGroup>
        </ControlPanel>

        <GaugeContainer>
          <GaugeItem>
            <AtomsGauge 
              value={tempValue.toString()} 
              unit="°C" 
              label="온도" 
              minValue={0}
              maxValue={40}
              goodRange={[18, 25]}
              normalRange={[26, 30]}
              showStatus={true} 
            />
          </GaugeItem>
          <GaugeItem>
            <AtomsGauge 
              value={humidityValue.toString()} 
              unit="%" 
              label="습도" 
              minValue={0}
              maxValue={100}
              goodRange={[40, 60]}
              normalRange={[30, 39]}
              showStatus={true} 
            />
          </GaugeItem>
          <GaugeItem>
            <AtomsGauge 
              value={vocValue.toString()} 
              unit="ppm" 
              label="VOC" 
              minValue={0}
              maxValue={200}
              goodRange={[0, 50]}
              normalRange={[51, 100]}
              showStatus={true} 
            />
          </GaugeItem>
          <GaugeItem>
            <AtomsGauge 
              value={co2Value.toString()} 
              unit="ppm" 
              label="CO2" 
              minValue={400}
              maxValue={2000}
              showStatus={false} 
            />
          </GaugeItem>
        </GaugeContainer>
      </TestSection>
    </Container>
  );
};

export default AtomsGaugeTest;

const Container = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 40px;
  font-family: Pretendard, sans-serif;
  background: #2d3748;
  min-height: 100vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding: 32px;
  background: #1a202c;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #a0aec0;
  line-height: 1.5;
`;

const TestSection = styled.div`
  background: #1a202c;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`;

const ControlPanel = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
  padding: 30px;
  background: #4a5568;
  border-radius: 8px;
`;

const ControlGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ControlLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
`;

const ControlSlider = styled.input`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: #E0E4EB;
  outline: none;
  -webkit-appearance: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #256EF4;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #256EF4;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

const ControlInfo = styled.div`
  font-size: 12px;
  color: #a0aec0;
  font-style: italic;
`;

const GaugeContainer = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
`;

const GaugeItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`; 